import { useQuery, queryOptions } from '@tanstack/react-query';

import { makeIsEnabled } from '@cast/utils';
import { QueryOptions } from '@cast/shared-types';
import { apiClient } from '@cast/infrastructure-api';
import { ClusterAutoscalerPoliciesV2 } from '@cast/types-cluster-autoscaler';

const POLICIES_V2_QUERY_KEY = 'cluster-autoscaler-policies-v2';

export const getPoliciesV2QueryKey = (params: Params) => {
  return [POLICIES_V2_QUERY_KEY, params];
};

type Params = {
  clusterId: string;
};

type UsePoliciesV2QueryArgs = {
  params: Params;
  options?: QueryOptions<ClusterAutoscalerPoliciesV2>;
};

export const getPoliciesV2QueryOptions = ({
  params,
  options,
}: UsePoliciesV2QueryArgs) =>
  queryOptions({
    queryKey: getPoliciesV2QueryKey(params),
    queryFn: async () => {
      const { data } = await apiClient.clusterAutoscaler.getPoliciesV2(params);
      return data;
    },
    ...options,
    enabled: makeIsEnabled(!!params.clusterId, options?.enabled),
  });

export const usePoliciesV2Query = ({
  params,
  options,
}: UsePoliciesV2QueryArgs) => {
  return useQuery(getPoliciesV2QueryOptions({ params, options }));
};
